import React from 'react'

import { Box, Typography } from "@mui/material"


export default function conditionNameColumn() {

	return {
		name: 'conditionName',
		label: 'Condition',
		options: {
			customBodyRowRenderLite: value => <Box sx={{ textAlign: "center" }} >
				<Typography fontWeight="bold">{value}</Typography>
			</Box>
		}
	}
}